import { isUploadedImage } from '@prezly/uploads';
import { Element } from "../Element.mjs";
import { isArrayOf, isEnum, isObject, isUuid } from "../validation/index.mjs";
export var GalleryNode;

(function (GalleryNode) {
  GalleryNode.TYPE = 'gallery';
  var Layout;

  (function (Layout) {
    Layout["CONTAINED"] = "contained";
    Layout["EXPANDED"] = "expanded";
    Layout["FULL_WIDTH"] = "full-width";
  })(Layout = GalleryNode.Layout || (GalleryNode.Layout = {}));

  var ImageSize;

  (function (ImageSize) {
    ImageSize["XSMALL"] = "XS";
    ImageSize["SMALL"] = "S";
    ImageSize["MEDIUM"] = "M";
    ImageSize["LARGE"] = "L";
    ImageSize["XLARGE"] = "XL";
  })(ImageSize = GalleryNode.ImageSize || (GalleryNode.ImageSize = {}));

  var Padding;

  (function (Padding) {
    Padding["LARGE"] = "L";
    Padding["MEDIUM"] = "M";
    Padding["SMALL"] = "S";
  })(Padding = GalleryNode.Padding || (GalleryNode.Padding = {}));

  function isGalleryNode(value) {
    return Element.isElement(value, GalleryNode.TYPE);
  }

  GalleryNode.isGalleryNode = isGalleryNode;

  function validateGalleryNode(value) {
    var isValid = isGalleryNode(value) && isUuid(value.uuid) && isEnum(value.layout, Layout) && isEnum(value.padding, Padding) && isEnum(value.thumbnail_size, ImageSize) && isArrayOf(value.images, image => Boolean(validateGalleryImage(image)));
    return isValid ? value : null;
  }

  GalleryNode.validateGalleryNode = validateGalleryNode;

  function validateGalleryImage(value) {
    var isValid = isObject(value) && typeof value.caption === 'string' && isUploadedImage(value.file);
    return isValid ? value : null;
  }

  GalleryNode.validateGalleryImage = validateGalleryImage;
})(GalleryNode || (GalleryNode = {}));